export const galleryPhotographyImages = { 
    "arteBa": {

        "ES": [
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-1.jpg",
                "tit": "ArteBA",
                "sub": "Fotografía de sala en la feria de arte ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-2.jpg",
                "tit": "ArteBA",
                "sub": "Fotografía de sala en la feria de arte ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-3.jpg",
                "tit": "ArteBA",
                "sub": "Fotografía de sala en la feria de arte ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-4.jpg",
                "tit": "ArteBA",
                "sub": "Fotografía de sala en la feria de arte ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-5.jpg",
                "tit": "ArteBA",
                "sub": "Fotografía de sala en la feria de arte ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-6.jpg",
                "tit": "ArteBA",
                "sub": "Fotografía de sala y perfirmance en la feria de arte ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-7.jpg",
                "tit": "ArteBA",
                "sub": "Fotografía de sala en la feria de arte ArteBA, Buenos Aires, Argentina"
            }
        ],

        "EN": [
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-1.jpg",
                "tit": "ArteBA",
                "sub": "Photographs at the contemporary art fair ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-2.jpg",
                "tit": "ArteBA",
                "sub": "Photographs at the contemporary art fair ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-3.jpg",
                "tit": "ArteBA",
                "sub": "Photographs at the contemporary art fair ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-4.jpg",
                "tit": "ArteBA",
                "sub": "Photographs at the contemporary art fair ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-5.jpg",
                "tit": "ArteBA",
                "sub": "Photographs at the contemporary art fair ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-6.jpg",
                "tit": "ArteBA",
                "sub": "Photographs at the contemporary art fair ArteBA, Buenos Aires, Argentina"
            },
            {   
                "location": "data/assets/compressed/ArteBA/ArteBA-7.jpg",
                "tit": "ArteBA",
                "sub": "Photographs at the contemporary art fair ArteBA, Buenos Aires, Argentina"
            }
        ]
    },

    "Bolivar": {

        "ES": [
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-1.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-2.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-3.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-4.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-5.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-6.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-7.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-8.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            }
        ],

        "EN": [
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-1.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-2.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-3.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-4.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-5.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-6.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-7.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/CasaBolivar/Bolivar-8.jpg",
                "tit": "Casa Bolívar",
                "sub": ""
            }
        ]
    },

    "NN": {

        "ES": [
            {   
                "location": "data/assets/compressed/NN/NN-1.jpg",
                "tit": "Galería NN",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/NN/NN-2.jpg",
                "tit": "Galería NN",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/NN/NN-3.jpg",
                "tit": "Galería NN",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/NN/NN-4.jpg",
                "tit": "Galería NN",
                "sub": ""
            }  
        ],

        "EN": [
            {   
                "location": "data/assets/compressed/NN/NN-1.jpg",
                "tit": "NN Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/NN/NN-2.jpg",
                "tit": "NN Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/NN/NN-3.jpg",
                "tit": "NN Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/NN/NN-4.jpg",
                "tit": "NN Gallery",
                "sub": ""
            }
        ]
    },

    "RI": {

        "ES": [
            {   
                "location": "data/assets/compressed/RI/RI-1.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/RI/RI-2.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/RI/RI-3.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/RI/RI-4.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            }  
        ],

        "EN": [
            {   
                "location": "data/assets/compressed/RI/RI-1.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/RI/RI-2.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/RI/RI-3.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/RI/RI-4.jpg",
                "tit": "Rocío Iannone",
                "sub": ""
            }
        ]
    },

    "Mirador": {

        "ES": [
            {   
                "location": "data/assets/compressed/Mirador/Mirador-1.jpg",
                "tit": "Sala Mirador",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-2.jpg",
                "tit": "Sala Mirador",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-3.jpg",
                "tit": "Sala Mirador",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-4.jpg",
                "tit": "Sala Mirador",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-5.jpg",
                "tit": "Sala Mirador",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-6.jpg",
                "tit": "Sala Mirador",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-7.jpg",
                "tit": "Sala Mirador",
                "sub": ""
            }
        ],

        "EN": [
            {   
                "location": "data/assets/compressed/Mirador/Mirador-1.jpg",
                "tit": "Mirador Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-2.jpg",
                "tit": "Mirador Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-3.jpg",
                "tit": "Mirador Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-4.jpg",
                "tit": "Mirador Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-5.jpg",
                "tit": "Mirador Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-6.jpg",
                "tit": "Mirador Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Mirador/Mirador-7.jpg",
                "tit": "Mirador Gallery",
                "sub": ""
            }
        ]
    },

    "Pasto1": {

        "ES": [
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-1.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-2.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-3.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-4.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-5.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-6.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            }
        ],

        "EN": [
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-1.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-2.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-3.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-4.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-5.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto1/Pasto1-6.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            }
        ]
    },

    "Pasto2": {

        "ES": [
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-1.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-2.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-3.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-4.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-5.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-6.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-7.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-8.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-9.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-10.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-11.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-12.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-13.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-14.jpg",
                "tit": "Sala Pasto",
                "sub": ""
            }
        ],

        "EN": [
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-1.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-2.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-3.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-4.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-5.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-6.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-7.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-8.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-9.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-10.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-11.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-12.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-13.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            },
            {   
                "location": "data/assets/compressed/Pasto2/Pasto2-14.jpg",
                "tit": "Pasto Gallery",
                "sub": ""
            }
        ]
    }

}




export const vehiclesPhotographyImages = [
    {   
        "location": "/img/photography/a1.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a2.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a3.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a4.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a5.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a6.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a7.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a8.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a9.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a10.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a11.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/a12.jpg",
        "tit": "",
        "sub": ""
    }
]


export const productPhotographyImages = [
    {   
        "location": "/img/photography/p1.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p2.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p3.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p4.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p5.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p6.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p7.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p8.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p10.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p11.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p12.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p13.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p14.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p15.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p16.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p17.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p18.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p19.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p20.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p21.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p22.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p23.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p24.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p25.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p26.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p27.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p28.jpg",
        "tit": "Akrilart",
        "sub": ""
    },
    {   
        "location": "/img/photography/p29.jpg",
        "tit": "Akrilart",
        "sub": ""
    }
]

export const housesPhotographyImages = [
    {   
        "location": "/img/photography/h1.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h2.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h3.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h4.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h5.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h6.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h7.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h8.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h10.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h11.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h12.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h13.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h14.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h15.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h16.jpg",
        "tit": "",
        "sub": ""
    },
    {   
        "location": "/img/photography/h17.jpg",
        "tit": "",
        "sub": ""
    }
]
